export default __webpack_public_path__ + "static/media/JuJiaMap.0ef196fd.jpg";